import React from 'react';
import { nth } from '../../../common/utils';

// https://github.com/react-tools/react-table#columns
export const COLUMNS = [
  nth,{
    Header: 'Eesnimi',
    accessor: 'given_name',
    maxWidth: 100
  },{
    Header: 'Perekonnanimi',
    accessor: 'family_name',
    maxWidth: 100
  },{
    Header: 'E-post',
    accessor: 'email',
    maxWidth: 100
  },{
    Header: 'Sünniaasta',
    accessor: 'year_of_birth',
    maxWidth: 100
  },{
    Header: 'Eriala',
    accessor: 'occupation',
    maxWidth: 100
  },{
    Header: 'Täpustus',
    accessor: 'occupation_details',
    maxWidth: 100
  },{
    Header: 'Riik',
    accessor: 'country_of_residence',
    maxWidth: 100
  },{
    Header: 'Maakond',
    accessor: 'county_of_residence',
    maxWidth: 100
  },
];

export const DEFAULTSORTED = [];
export const DEFAULTPAGESIZE = 100;



// WEBPACK FOOTER //
// ./src/private/admin/components/CsvImport/table.conf.js